import { useRef } from 'react';
import Slider from 'react-slick';

const useSyncTableHeaderAndTableData = () => {
  const headerRef = useRef<Slider>(null);
  const tableRef = useRef<Slider>(null);

  const onNext = () => {
    if (headerRef.current && tableRef.current) {
      headerRef.current.slickNext();
      tableRef.current.slickNext();
    }
  };

  const onPrev = () => {
    if (headerRef.current && tableRef.current) {
      headerRef.current.slickPrev();
      tableRef.current.slickPrev();
    }
  };

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    beforeChange(_currentSlide: number, nextSlide: number) {
      if (headerRef.current && tableRef.current) {
        headerRef.current.slickGoTo(nextSlide);
        tableRef.current.slickGoTo(nextSlide);
      }
    },
    responsive: [
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1157,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return { headerRef, tableRef, onPrev, onNext, settings };
};

export default useSyncTableHeaderAndTableData;
